import { render } from "./droppable.vue?vue&type=template&id=05a5ab64&lang=pug"
import script from "./droppable.vue?vue&type=script&lang=js"
export * from "./droppable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__